import ModalPlanAccess from './ModalPlanAccess'

export default ModalPlanAccess

// eslint-disable-next-line import/export
export * from './ModalPlanAccess'
